import React from "react";

// styles
import * as Styled from './styles'
import * as SharedStyled from '../styles'

// libs
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

function Header({logo, setGoBack}) {
    return (
        <Styled.Header>
            <Styled.TopLine />

            <SharedStyled.Logo>
                { logo }
            </SharedStyled.Logo>

            {
                setGoBack &&
                <Styled.GoBackButton onClick={ () => setGoBack(true) }>
                    <FontAwesomeIcon icon={ faSearch } />
                    <span>Search Page</span>
                </Styled.GoBackButton>
            }

        </Styled.Header>
    );
}

export default Header;
